import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DictionaryService } from '@secca/core/services/dictionary.service';
import { CaseStateService } from '@secca/core/state-services/case-state.service';
import { InsuranceService } from '@secca/core/services/insurance.service';
import { AutoUnsubscribe } from '@secca/shared/decorators/auto-unsubscribe';
import { Subscription } from 'rxjs';
import { ServiceOrderType } from '@secca/shared/models/service-order-type';
import { CommitmentType } from '@secca/shared/models/commitment-type';
import { DropdownWithHoverDictionary } from '@secca/shared/models/dropdownWithHoverDictionary';
import { ServiceTypeEnum, StatusTypes } from '@secca/shared/models/enums';
import { AccountGopInfo } from '@secca/shared/models/account-gop-info';
import { AccountGopService } from '@secca/core/services/account-gop.service';
import { DurationChangeSignalsService } from '@secca/core/services/sugguester/duration-change-signals.service';

@Component({
    selector: 'app-sub-commitment-type',
    templateUrl: './sub-commitment-type.component.html',
    styleUrls: ['./sub-commitment-type.component.scss'],
    standalone: false
})
@AutoUnsubscribe
export class SubCommitmentTypeComponent implements OnInit {
  supplierId: number = null;

  accountGopInfo: AccountGopInfo | null = null;
  @Input() caseId: string;
  @Input() commitmentType: CommitmentType;
  @Input() readOnlyMode: boolean = false;
  @Input() serviceOrderType: ServiceOrderType;
  @Input() status: StatusTypes;

  @Output() commitmentTypeChange = new EventEmitter<CommitmentType>();

  $caseSubscr: Subscription;
  $insuranceServiceSubcr: Subscription;
  $gopInfoSubscr: Subscription;

  commitmentTypes: DropdownWithHoverDictionary[] = [];
  private filteredCommitmentTypes: CommitmentType[];

  constructor(private dictionaryService: DictionaryService,
              private caseStateService: CaseStateService,
              private insuranceService: InsuranceService,
              private accountGopService: AccountGopService,
              private durationChangeSignals: DurationChangeSignalsService) {
  }

  ngOnInit() {
    this.filteredCommitmentTypes = [];
    this.$caseSubscr = this.caseStateService.getCase().subscribe(caseObject => {
      const caseId = caseObject.id;
      this.commitmentTypes = this.dictionaryService.getCommitmentTypeDictionary(this.serviceOrderType.commitmentTypes);
      if (this.caseId === caseId.toString()) {
        this.$insuranceServiceSubcr = this.insuranceService.getCustomerProfileInfo(caseId).subscribe(info => {
          this.adjustCommitmentsTypes(info.claimsAgreement);
        });
      }
    });
    this.$gopInfoSubscr = this.accountGopService.getAccountGopInfo().subscribe({
      next: (gop) => {
        this.accountGopInfo = gop;
        this.setFirstCommitType(this.commitmentTypes, this.accountGopInfo);
      },
      error: (error) => console.error('Error fetching accountGop:', error)
    });
  }

  private adjustCommitmentsTypes(claimsAgreement?: boolean) {
    this.filteredCommitmentTypes = this.serviceOrderType.commitmentTypes.filter(
      type => !type.refund || !!type.sosClaims === !!claimsAgreement);
    this.commitmentTypes = this.dictionaryService.getCommitmentTypeDictionary(this.filteredCommitmentTypes);
    this.setFirstCommitType(this.commitmentTypes, this.accountGopInfo);
  }

  commitmentTypeChanged(commitmentType: DropdownWithHoverDictionary): void {
    this.commitmentType = commitmentType?.value;
    this.commitmentTypeChange.emit(commitmentType?.value);
    this.durationChangeSignals.notifyChange(commitmentType?.value);
  }


  setFirstCommitType(commitmentTypes: DropdownWithHoverDictionary[], accountGop?: AccountGopInfo): void {
    // If no gopInfo we cannot select anything and leave all as is
    if (!accountGop) {
      return;
    }
    if (!this.supplierId || this.supplierId === accountGop.supplierId) {
      if (this.commitmentType?.businessKey !== undefined && accountGop.commitmentTypeCode !== this.commitmentType?.businessKey) {
        this.supplierId = accountGop.supplierId;
        return;
      }
    }


    const commitmentType = accountGop?.commitmentTypeCode
      ? commitmentTypes.find(ct => ct.value.businessKey === accountGop.commitmentTypeCode)
      : undefined;
    // Deferring to make the update is run in its own change detection cycle, otherwise NG0100 is seen
    Promise.resolve().then(() => {
      this.commitmentTypeChanged(commitmentType);
      this.supplierId = accountGop?.supplierId;
    });
  }

  get ServiceTypeEnum() {
    return ServiceTypeEnum;
  }
}
